/* eslint-disable arrow-body-style */
import { INSTANCE_CONFIG } from '@/utils/common';
import http from '@/utils/http';
import { getAuthorization } from '@/utils/utils';
import axios from "axios";

export const getByDeviceMobileMap: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/byDevice/device/deviceMap',
    method: 'post',
    data: payload,
  }) as Promise<any>;
}

export const getGlobalDeviceSummary: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/globalView/byDevice/device/summary',
    method: 'post',
    data: payload,
  }) as Promise<any>;
}

export const getPresetInfo: (presetId: string) => Promise<any> = (presetId) => {
  return http({
    url: `/api/v1/permission/preset/guest_token/intelligence/all/${presetId}`,
    method: 'get',
    data: {},
  }) as Promise<any>;
}


export const DownloadMobileDevice = (payload: any) => {
  return new Promise((resolve, reject) => {
    let authorization = window.sessionStorage.getItem('authorization') || '';
    axios({
      url: `/api/v1/intelligence_pc/mobileDevice/stats/downloads_excel`,
      method: 'post',
      data: payload,
      errorHandler: true,
      responseType: 'arraybuffer',
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: authorization,
      }
    })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        }
      })
      .catch(function (error) {
        console.log(error)
        reject()
      })
  })
}

export const DownloadGlobalViewExcel = (payload: any) => {
  return new Promise((resolve, reject) => {
    let authorization = window.sessionStorage.getItem('authorization') || '';
    axios({
      url: `/api/v1/intelligence_pc/globalView/byDevice/device/downloads_excel`,
      method: 'post',
      data: payload,
      errorHandler: true,
      responseType: 'arraybuffer',
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: authorization,
      }
    })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        }
      })
      .catch(function (error) {
        console.log(error)
        reject()
      })
  })
}

export const DownloadMobileDeviceDataExcel = (payload: any) => {
  return new Promise((resolve, reject) => {
    let authorization = window.sessionStorage.getItem('authorization') || '';
    axios({
      url: `/api/v1/intelligence_pc/mobileDevice/stats/mobileDeviceData/downloads_excel`,
      method: 'post',
      data: payload,
      errorHandler: true,
      responseType: 'arraybuffer',
      headers: {
        Accept: "application/json, text/plain, */*",
        Authorization: authorization,
      }
    })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          resolve(response.data)
        }
      })
      .catch(function (error) {
        console.log(error)
        reject()
      })
  })
}